<template>
<header class="header">
  <div class="container">
    <div class="header__body">
      <div class="header__logo" @click="headerFalse ()">
        <a href="#sectionScroll1">
          <svg width="46" height="53" viewBox="0 0 46 53" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 13.25L22.8973 0L45.8029 13.25L46 39.6374L22.8973 53L0 39.75V13.25ZM4.57684 18.7272V29.2345L11.9004 33.3403V41.1048L20.6023 46.1779V27.9078L4.57684 18.7272ZM41.2408 18.7272L25.2153 27.9062V46.1762L33.909 41.1032V33.3486L41.2425 29.2345L41.2408 18.7272ZM6.86197 14.5783L22.8628 23.7307L38.8965 14.5005L30.4181 9.64434L22.9483 13.9407L15.4357 9.593L6.86197 14.5783Z" fill="white"/>
          </svg>
          <span>SolarBox</span>
        </a>
      </div>
      <button class="header__burger" @click="headerUpdate ()" v-bind:class="{ active: headerState }"><span></span></button>
      <transition name="headerMenu">
        <nav class="header__menu" v-show="headerState">
          <ul class="header__list">
            <li class="header__link" @click="headerFalse ()" v-if="HEADER_LANG === 'en'">
              <a href="#sectionScroll2">about us</a>
            </li>
            <li class="header__link" @click="headerFalse ()" v-if="HEADER_LANG === 'ru'">
              <a href="#sectionScroll2">О нас</a>
            </li>
            <li class="header__link" @click="headerFalse ()" v-if="HEADER_LANG === 'en'">
              <a href="#sectionScroll3">projects</a>
            </li>
            <li class="header__link" @click="headerFalse ()" v-if="HEADER_LANG === 'ru'">
              <a href="#sectionScroll3">Проекты</a>
            </li>
            <li class="header__link" @click="headerFalse ()" v-if="HEADER_LANG === 'en'">
              <a href="#sectionScroll4">contact</a>
            </li>
            <li class="header__link" @click="headerFalse ()" v-if="HEADER_LANG === 'ru'">
              <a href="#sectionScroll4">контакты</a>
            </li>
            <li class="header__lang_mob" @click="headerLangUpdate ()">
              <span>{{HEADER_LANG}}</span>
              <svg width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.4969 0H0.503126C0.0833986 0 -0.150967 0.539654 0.108966 0.908072L7.10584 10.7879C7.30612 11.0707 7.69175 11.0707 7.89416 10.7879L14.891 0.908072C15.151 0.539654 14.9166 0 14.4969 0Z" fill="white"/>
              </svg>
              <span>{{OTHER_LANG}}</span>
            </li>
          </ul>
        </nav>
      </transition>
      <div class="header__lang">
        <span>{{HEADER_LANG}}</span>
        <svg width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.4969 0H0.503126C0.0833986 0 -0.150967 0.539654 0.108966 0.908072L7.10584 10.7879C7.30612 11.0707 7.69175 11.0707 7.89416 10.7879L14.891 0.908072C15.151 0.539654 14.9166 0 14.4969 0Z" fill="white"/>
        </svg>
        <div class="window">
          <button @click="headerLangUpdate ()">
            {{OTHER_LANG}}
          </button>
        </div>
      </div>
    </div>
  </div>
</header>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
export default {
  name: "AppHeader",
  computed: {
    ...mapGetters([
        'headerState',
        'HEADER_LANG',
        'OTHER_LANG'
    ])
  },
  methods: {
    ...mapActions([
      'toggleHeaderState',
      'falseHeaderState',
      'UPDATE_HEADER_HEIGHT',
      'UPDATE_HEADER_LANG'
    ]),
    headerUpdate () {
      this.toggleHeaderState()
    },
    headerHeightUpdate () {
      this.UPDATE_HEADER_HEIGHT()
    },
    headerLangUpdate () {
      this.UPDATE_HEADER_LANG()
    },
    headerFalse () {
      this.falseHeaderState()
    }
  },
  mounted() {
    this.headerHeightUpdate ()
  }
}
</script>

<style scoped lang="scss">
// Const
$cRed: #de3024;
$cBlack: #252525;
$cYellow: #FFA630;
$cWhite: #FFFFFF;
$cGrey: rgba(55, 57, 46, .5);


.header {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  z-index: 23;
  padding: 25px 0;
  @media (max-width: 997.98px) {
    padding: 15px 0;
  }
  @media (max-width: 575.98px) {
    padding: 5px 0;
  }
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: $cRed;
    z-index: 21;
    box-shadow: 0 0 8px $cGrey;
  }
  &__body {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 40px;
  }
  &__logo {
    z-index: 22;
    flex: 0 0 auto;
    width: auto;
    overflow: hidden;
    span {
      transition: .2s linear all;
      opacity: 0;
      transform: translateX(-10px);
    }
    &:hover {
      span {
        opacity: 1;
        transform: translateX(0);
      }
    }
    a {
      font-weight: bold;
      font-size: 3rem;
      color: $cWhite;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      cursor: pointer;
      svg {
        transform: translateX(10px);
        max-width: 50px;
        height: 50px;
        object-fit: contain;
        display: block;
        object-position: center;
        margin-right: 15px;
        transition: .2s linear all;
        path {
          fill: $cWhite;
          transition: .2s linear all;
        }
      }
      &:hover {
        color: $cYellow;
        svg {
          transform: translateX(0);
          path {
            fill: $cYellow;
          }
        }
      }
      &:active {
        opacity: .6;
      }
    }
  }
  &__link {
    a {
      cursor: pointer;
      text-transform: uppercase;
      font-weight: normal;
      font-size: 1.8rem;
      color: $cWhite;
      position: relative;
      transition: .1s linear all;
      &:after {
        position: absolute;
        content: '';
        background-color: $cYellow;
        width: 100%;
        height: 2px;
        bottom: -2px;
        left: 0;
        transform: scale(0);
        transition: .1s linear all;
      }
      &:hover {
        color: $cYellow;
        &:after {
          transform: scale(1);
        }
      }
      &:active {
        opacity: .6;
      }
    }
  }
  &__lang {
    z-index: 22;
    color: $cWhite;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-size: 1.8rem;
    text-transform: uppercase;
    position: relative;
    cursor: default;
    transition: .1s linear all;
    @media (max-width: 997.98px) {
      display: none;
    }
    svg {
      margin-left: 15px;
      max-width: 10px;
      height: auto;
      object-fit: contain;
      object-position: center;
      path {
        fill: $cWhite;
        transition: .1s linear all;
      }
    }
    .window {
      overflow: hidden;
      width: 100%;
      height: 0;
      position: absolute;
      top: 100%;
      right: 0;
      background-color: $cWhite;
      padding: 0 10px;
      transition: .1s linear all;
      &:hover {
        opacity: .9;
      }
      &:active {
        opacity: .6;
      }
      button {
        color: $cBlack;
        cursor: pointer;
        font-size: 1.8rem;
        text-transform: uppercase;
        text-align: center;
        width: 100%;
        margin: 0;
        height: 100%;
      }
    }
    &:hover {
      color: $cYellow;
      svg {
        transform: rotate(180deg);
        path {
          fill: $cYellow;
        }
      }
      .window {
        height: 100%;
        padding: 10px;
      }
    }
    &_mob {
      display: none;
      @media (max-width: 997.98px) {
        display: block;
        text-align: center;
        span {
          font-size: 2.6rem;
          text-transform: uppercase;
          transition: .1s linear all;
          color: $cWhite;
        }
        svg {
          max-width: 10px;
          height: auto;
          object-fit: contain;
          object-position: center;
          margin: 0 10px;
          transform: rotate(270deg) translateX(3px);
        }
      }
    }
  }
  &__list {
    display: flex;
    position: relative;
    z-index: 22;
    @media (max-width: 997.98px) {
      flex-direction: column;
    }
    li {
      margin-right: 3rem;
      &:last-child {
        margin-right: 0;
      }
      @media (max-width: 997.98px) {
        margin-right: 0;
        margin-bottom: 30px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
  &__burger {
    display: none;
    @media (max-width: 997.98px) {
      display: block;
      position: relative;
      width: 30px;
      height: 20px;
      border: none;
      background-color: transparent;
      z-index: 22;
      span {
        overflow: visible;
        position: absolute;
        width: 100%;
        height: 2px;
        top: 50%;
        left: 0;
        transform: translateY(-50%) scale(1);
        background-color: $cWhite;
        opacity: 1;
        transition: .2s linear all;
      }
      &:before, &:after {
        content: '';
        position: absolute;
        width: 100%;
        height: 2px;
        left: 0;
        background-color: $cWhite;
        transition: .2s linear all;
      }
      &:before {
        top: 0;
      }
      &:after {
        bottom: 0;
      }
      &.active {
        span {
          transform: translateY(-50%) scale(0);
          opacity: 0;
        }
        &:before {
          top: 50%;
          transform: rotate(-45deg) translateY(-50%);
        }
        &:after {
          bottom: 50%;
          transform: rotate(45deg) translateY(50%);
        }
      }
    }
  }
  &__menu {
    @media (min-width: 997.98px) {
      opacity: 1 !important;
      display: block !important;
    }
    @media (max-width: 997.98px) {
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      position: fixed;
      background-color: $cRed;
      padding: 100px 20px 30px 20px;
      box-sizing: border-box;
      overflow: auto;
      transition: .2s linear all;
      text-align: center;
      a {
        font-size: 3rem;
      }
    }
  }
}

.headerMenu-enter-active {
  animation: headerMenu .5s;
}
.headerMenu-leave-active {
  animation: headerMenu .5s reverse;
}
@keyframes headerMenu {
  0% {
    opacity: 0;
    display: none;
  }
  100% {
    display: block;
    opacity: 1;
  }
}
</style>
